module.exports = __webpack_public_path__ + "static/img/tu3.4e35b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tu3.png
// module id = BB5G
// module chunks = 1